export const countries = {
  "af": "Afghanistan",
  "ax": "Aland Islands",
  "al": "Albania",
  "dz": "Algeria",
  "as": "American Samoa",
  "ad": "Andorra",
  "ao": "Angola",
  "ai": "Anguilla",
  "ag": "Antigua",
  "ar": "Argentina",
  "am": "Armenia",
  "aw": "Aruba",
  "au": "Australia",
  "at": "Austria",
  "az": "Azerbaijan",
  "bs": "Bahamas",
  "bh": "Bahrain",
  "bd": "Bangladesh",
  "bb": "Barbados",
  "by": "Belarus",
  "be": "Belgium",
  "bz": "Belize",
  "bj": "Benin",
  "bm": "Bermuda",
  "bt": "Bhutan",
  "bo": "Bolivia",
  "ba": "Bosnia",
  "bw": "Botswana",
  "bv": "Bouvet Island",
  "br": "Brazil",
  "vg": "British Virgin Islands",
  "bn": "Brunei",
  "bg": "Bulgaria",
  "bf": "Burkina Faso",
  "mm": "Burma",
  "bi": "Burundi",
  "tc": "Caicos Islands",
  "kh": "Cambodia",
  "cm": "Cameroon",
  "ca": "Canada",
  "cv": "Cape Verde",
  "ky": "Cayman Islands",
  "cf": "Central African Republic",
  "td": "Chad",
  "cl": "Chile",
  "cn": "China",
  "cx": "Christmas Island",
  "cc": "Cocos Islands",
  "co": "Colombia",
  "km": "Comoros",
  "cd": "Congo",
  "cg": "Congo Brazzaville",
  "ck": "Cook Islands",
  "cr": "Costa Rica",
  "ci": "Cote Divoire",
  "hr": "Croatia",
  "cu": "Cuba",
  "cy": "Cyprus",
  "cz": "Czech Republic",
  "dk": "Denmark",
  "dj": "Djibouti",
  "dm": "Dominica",
  "do": "Dominican Republic",
  "ec": "Ecuador",
  "eg": "Egypt",
  "sv": "El Salvador",
  "gq": "Equatorial Guinea",
  "er": "Eritrea",
  "ee": "Estonia",
  "et": "Ethiopia",
  "eu": "Europeanunion",
  "fk": "Falkland Islands",
  "fo": "Faroe Islands",
  "fj": "Fiji",
  "fi": "Finland",
  "fr": "France",
  "gf": "French Guiana",
  "pf": "French Polynesia",
  "tf": "French Territories",
  "ga": "Gabon",
  "gm": "Gambia",
  "ge": "Georgia",
  "de": "Germany",
  "gh": "Ghana",
  "gi": "Gibraltar",
  "gr": "Greece",
  "gl": "Greenland",
  "gd": "Grenada",
  "gp": "Guadeloupe",
  "gu": "Guam",
  "gt": "Guatemala",
  "gn": "Guinea",
  "gw": "Guinea-Bissau",
  "gy": "Guyana",
  "ht": "Haiti",
  "hm": "Heard Island",
  "hn": "Honduras",
  "hk": "Hong Kong",
  "hu": "Hungary",
  "is": "Iceland",
  "in": "India",
  "io": "Indian Ocean Territory",
  "id": "Indonesia",
  "ir": "Iran",
  "iq": "Iraq",
  "ie": "Ireland",
  "il": "Israel",
  "it": "Italy",
  "jm": "Jamaica",
  "sj": "Jan Mayen",
  "jp": "Japan",
  "jo": "Jordan",
  "kz": "Kazakhstan",
  "ke": "Kenya",
  "ki": "Kiribati",
  "kw": "Kuwait",
  "kg": "Kyrgyzstan",
  "la": "Laos",
  "lv": "Latvia",
  "lb": "Lebanon",
  "ls": "Lesotho",
  "lr": "Liberia",
  "ly": "Libya",
  "li": "Liechtenstein",
  "lt": "Lithuania",
  "lu": "Luxembourg",
  "mo": "Macau",
  "mk": "Macedonia",
  "mg": "Madagascar",
  "mw": "Malawi",
  "my": "Malaysia",
  "mv": "Maldives",
  "ml": "Mali",
  "mt": "Malta",
  "mh": "Marshall Islands",
  "mq": "Martinique",
  "mr": "Mauritania",
  "mu": "Mauritius",
  "yt": "Mayotte",
  "mx": "Mexico",
  "fm": "Micronesia",
  "md": "Moldova",
  "mc": "Monaco",
  "mn": "Mongolia",
  "me": "Montenegro",
  "ms": "Montserrat",
  "ma": "Morocco",
  "mz": "Mozambique",
  "na": "Namibia",
  "nr": "Nauru",
  "np": "Nepal",
  "nl": "Netherlands",
  "an": "Netherlandsantilles",
  "nc": "New Caledonia",
  "pg": "New Guinea",
  "nz": "New Zealand",
  "ni": "Nicaragua",
  "ne": "Niger",
  "ng": "Nigeria",
  "nu": "Niue",
  "nf": "Norfolk Island",
  "kp": "North Korea",
  "mp": "Northern Mariana Islands",
  "no": "Norway",
  "om": "Oman",
  "pk": "Pakistan",
  "pw": "Palau",
  "ps": "Palestine",
  "pa": "Panama",
  "py": "Paraguay",
  "pe": "Peru",
  "ph": "Philippines",
  "pn": "Pitcairn Islands",
  "pl": "Poland",
  "pt": "Portugal",
  "pr": "Puerto Rico",
  "qa": "Qatar",
  "re": "Reunion",
  "ro": "Romania",
  "ru": "Russia",
  "rw": "Rwanda",
  "sh": "Saint Helena",
  "kn": "Saint Kitts and Nevis",
  "lc": "Saint Lucia",
  "pm": "Saint Pierre",
  "vc": "Saint Vincent",
  "ws": "Samoa",
  "sm": "San Marino",
  "gs": "Sandwich Islands",
  "st": "Sao Tome",
  "sa": "Saudi Arabia",
  "gb sct": "Scotland",
  "sn": "Senegal",
  "cs": "Serbia",
  "rs": "Serbia",
  "sc": "Seychelles",
  "sl": "Sierra Leone",
  "sg": "Singapore",
  "sk": "Slovakia",
  "si": "Slovenia",
  "sb": "Solomon Islands",
  "so": "Somalia",
  "za": "South Africa",
  "kr": "South Korea",
  "es": "Spain",
  "lk": "Sri Lanka",
  "sd": "Sudan",
  "sr": "Suriname",
  "sz": "Swaziland",
  "se": "Sweden",
  "ch": "Switzerland",
  "sy": "Syria",
  "tw": "Taiwan",
  "tj": "Tajikistan",
  "tz": "Tanzania",
  "th": "Thailand",
  "tl": "Timorleste",
  "tg": "Togo",
  "tk": "Tokelau",
  "to": "Tonga",
  "tt": "Trinidad",
  "tn": "Tunisia",
  "tr": "Turkey",
  "tm": "Turkmenistan",
  "tv": "Tuvalu",
  "ae": "U.A.E.",
  "ug": "Uganda",
  "ua": "Ukraine",
  "gb": "United Kingdom",
  "us": "United States",
  "uy": "Uruguay",
  "um": "US Minor Islands",
  "vi": "US Virgin Islands",
  "uz": "Uzbekistan",
  "vu": "Vanuatu",
  "va": "Vatican City",
  "ve": "Venezuela",
  "vn": "Vietnam",
  "gb wls": "Wales",
  "wf": "Wallis and Futuna",
  "eh": "Western Sahara",
  "ye": "Yemen",
  "zm": "Zambia",
  "zw": "Zimbabwe"
}